import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from 'src/app/settings.service';
import { ApiService } from 'src/app/api.service';
import { LambdaService } from 'src/app/lambda.service';
import { ThemingService } from 'src/app/theming.service';
import { ExportSuppliersService } from 'src/app/export-suppliers.service';
declare let $: any;

@Component({
selector: 'app-supplier',
templateUrl: './supplier.component.html',
styleUrls: ['./supplier.component.scss']
})

export class SupplierComponent implements OnInit {
@Input() collectionId: string = '';

suppliers: any[] = [{}]
loading: boolean = false;
searchString: string = '';
modalDelete = false;
supplierIdToDelete: any;
supplierReportData: any;
themingData: any;

constructor(
  private apiService: ApiService,
  private settingsService: SettingsService,
  public router: Router,
  public themingService: ThemingService,
  private lambdaService: LambdaService,
  private exportSuppliersService: ExportSuppliersService
) {
  }

ngOnInit(): void {
  this.themingData = (this.themingService as any)?.shopTheming;
  this.getSuppliers()
}


  async getSuppliers(): Promise<void> {
    try {
      const response: any = await this.lambdaService.getSuppliers(this.themingService.shopId);
      this.suppliers = Array.isArray(response.suppliers) ? response.suppliers : [];
    } catch (error) {
      console.error('Error fetching suppliers:', error);
      this.suppliers = [];
    }
  }

  searchSuppliers(){
  }

  setEditingSupplier(supplierId: string){
    this.settingsService.setEditingSupplier(supplierId);
  }

  setCreatingSupplier(){
    this.settingsService.setCreatingSupplier();
  }

  deleteSupplier(response: number) {
    if (response) {
      this.loading = true;
      this.lambdaService.deleteSupplier(this.themingService.shopId, this.supplierIdToDelete)
        .then((data) => {
          this.getSuppliers();
          $('#deleteSupplierModal').modal('show');
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    }
    this.modalDelete = false;
  }

  async downloadClientsFile(format: 'excel' | 'json' | 'csv' | 'txt', supplierId: number) {
    if (![4].includes(this.themingService.shopTheming[0].shopId)) {
      return;
    }
    this.getSupplierReportData(supplierId).then(()=>{
      this.exportSuppliersService.exportToFile(this.supplierReportData, supplierId, format);
    })
  }

  async getSupplierReportData(supplierId: number){
    try {
    const response: any = await this.lambdaService.getSupplierReportData(this.themingService.shopId, supplierId);
    console.log("supdatatoexp:",response);
    this.supplierReportData = response.data;
  } catch (error) {
    console.error('Error fetching suppliers:', error);
    this.supplierReportData = [];
  }
  }
  

  closeModal(){
    $('#deleteSupplierModal').modal('hide');
  }
}

